
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/image-zoom/image-zoom.js'
      import type { DdsZoomEvent } from '../../events/events'
import type { DdsUnzoomEvent } from '../../events/events'
      export type { DdsZoomEvent } from '../../events/events'
export type { DdsUnzoomEvent } from '../../events/events'

      const tagName = 'dap-ds-image-zoom'

      /**
 * `dap-ds-image-zoom`
 * @summary An image zoom component that provides a Medium.com-style zoom experience. Click an image to expand it to fill the viewport with a smooth animation.
 * @element dap-ds-image-zoom
 * @title - Image Zoom
 *
 * @property {boolean} open - The open/zoomed state. Can be used for controlled mode.
 * @property {boolean} isDisabled - Disables zoom functionality.
 * @property {number} zoomMargin - Margin in pixels from viewport edges when zoomed. Default is 0.
 * @property {string} expandButtonAriaLabel - Accessible label for the zoom trigger. Default is 'Expand image'.
 * @property {string} unzoomButtonAriaLabel - Accessible label for the unzoom button. Default is 'Minimize image'.
 * @property {boolean} hideButtons - Hides the expand and unzoom buttons. Default is false.
 * @property {boolean} canSwipeToUnzoom - Enables swipe gesture to close when zoomed. Default is true.
 * @property {number} swipeToUnzoomThreshold - Swipe distance in pixels required to trigger unzoom. Default is 10.
 * @property {string} zoomSrc - URL of a higher quality image to display when zoomed. Falls back to the slotted image src.
 *
 * @event {CustomEvent} dds-zoom - Fires when the image is about to zoom. Cancelable via event.preventDefault().
 * @event {CustomEvent} dds-unzoom - Fires after the image has unzoomed.
 *
 * @slot - The image or content element to zoom. Should contain an <img> element.
 *
 * @csspart trigger - The zoom trigger wrapper element.
 * @csspart dialog - The zoom dialog element.
 * @csspart overlay - The backdrop overlay element.
 * @csspart zoomed-image - The zoomed image element.
 * @csspart unzoom-button - The button to close the zoomed view.
 * @csspart expand-button - The button to expand the image.
 * @csspart expand-button-base - The base of the expand button.
 * @csspart expand-button-content - The content of the expand button.
 * @csspart unzoom-button-base - The base of the unzoom button.
 * @csspart unzoom-button-content - The content of the unzoom button.
 * @csspart expand-button-icon - The icon of the expand button.
 * @csspart unzoom-button-icon - The icon of the unzoom button.
 *
 * @cssproperty --dds-image-zoom-overlay-bg - Overlay background color (default: rgba(0, 0, 0, 0.8)).
 * @cssproperty --dds-image-zoom-transition-speed - Animation duration (default: 300ms).
 * @cssproperty --dds-image-zoom-transition-timing - Animation timing function (default: var(--dds-easing-ease-in-out, ease-in-out)).
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsZoom: 'dds-zoom' as EventName<DdsZoomEvent>,
onDdsUnzoom: 'dds-unzoom' as EventName<DdsUnzoomEvent>
        },
        displayName: "DapDSImageZoom"
      })

      export default reactWrapper
    